import { Fragment, MouseEvent, useState } from "react";
import { FormattedMessage } from "react-intl";
import { matchPath, useLocation } from "react-router";
import { NavLink as RouterNavLink } from "react-router-dom";

import { useUser } from "@dzambalaorg/provider-user";
import type { IUser } from "@framework/types";
import { useLogout } from "@dzambalaorg/provider-wagmi";
import { Avatar, Button, Menu } from "@dzambalaorg/ui-kit";

export const Sections = () => {
  const { logout } = useLogout();
  const location = useLocation();

  const [anchor, setAnchor] = useState<Element | null>(null);

  const user = useUser<IUser>();

  const handleMenuOpen = (event: MouseEvent): void => {
    setAnchor(event.currentTarget);
  };

  const handleMenuClose = (): void => {
    setAnchor(null);
  };

  const logoutHandler = async (e: MouseEvent): Promise<void> => {
    e.preventDefault();
    await logout();
    handleMenuClose();
  };

  if (!user.isAuthenticated()) {
    return null;
  }

  return (
    <Fragment>
      <Button
        intent={"icon"}
        aria-owns={anchor ? "material-appbar" : undefined}
        aria-haspopup="true"
        data-testid="OpenSiteMenuButton"
        onClick={handleMenuOpen}
        color="inherit"
      >
        <Avatar alt={user.profile.displayName} src={user.profile.imageUrl}>
          {user.profile.displayName?.substr(0, 1)}
        </Avatar>
      </Button>
      <Menu id="material-appbar" anchorEl={anchor} open={!!anchor} onClose={handleMenuClose}>
        <Menu.Item<typeof RouterNavLink>
          onClick={handleMenuClose}
          component={RouterNavLink}
          to="/dashboard"
          color="inherit"
          selected={!!matchPath(location.pathname, "/dashboard")}
        >
          <FormattedMessage id="components.header.menu.dashboard" />
        </Menu.Item>
        <Menu.Item<typeof RouterNavLink>
          onClick={handleMenuClose}
          color="inherit"
          component={RouterNavLink}
          to="/profile"
          selected={!!matchPath(location.pathname, "/profile")}
        >
          <FormattedMessage id="components.header.menu.profile" />
        </Menu.Item>
        <Menu.Item<typeof RouterNavLink>
          onClick={handleMenuClose}
          color="inherit"
          component={RouterNavLink}
          to="/profile/settings"
          selected={!!matchPath(location.pathname, "/profile/settings")}
        >
          <FormattedMessage id="components.header.menu.settings" />
        </Menu.Item>
        <Menu.Item<typeof RouterNavLink>
          onClick={handleMenuClose}
          color="inherit"
          component={RouterNavLink}
          to="/merchant"
          selected={!!matchPath(location.pathname, "/merchant")}
        >
          <FormattedMessage id="components.header.menu.merchant" />
        </Menu.Item>
        <Menu.Item onClick={logoutHandler}>
          <FormattedMessage id="components.header.menu.logout" />
        </Menu.Item>
      </Menu>
    </Fragment>
  );
};
